export default __webpack_public_path__ + "static/media/resultX33_34_test_top1000.fc1bc040.csv";